





















































































import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { Controlador as Model } from "../proveedores-controlador";
import moment, { Moment } from 'moment';
@Component( {
    name: "Componente",
    props: {},
    components: {
    }
} )
export default class Componente extends Vue
{
    get Controlador() { return Model; }

    Estado: 'cargando' | 'iniciado' = 'iniciado';
    public Hoy: string = moment().toSQL();
    public FechaDeEntrega: { Fecha: Moment; } = null;
    public FechaSeleccionada: string = null;
    public ee: any = null;
    @Watch( 'FechaSeleccionada' )
    onFecha()
    {
        this.Estado = 'cargando';
        this.Controlador.ModificarFecha( this.FechaSeleccionada );
    }

    iniciar()
    {
        this.$nextTick( () => this.Estado = 'iniciado' );
    }
    mounted()
    {
        this.Controlador.$on( 'change', () => this.iniciar() );
    }
}
